import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SIDEBAR_ITEMS, IMG } from '../../data/homeData';
import { SIDEBAR_TREE } from '../../data/sidebarTree';
import IconImg from './IconImg';

const CAROUSEL_IMGS = [1, 2, 3, 4].map((n) => `${IMG}/sidebar-slider-casino-image-${n}.png`);
/* mobile-only logo (CSS hides it on desktop); local brand asset, onError-guarded */
const MOBILE_LOGO = '/images/reddy/reddybook-logo.png';

const slugify = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

/* Bottom promo carousel — auto-rotates every 4s, no Bootstrap JS. */
function SidebarCarousel() {
  const [idx, setIdx] = useState(0);
  const n = CAROUSEL_IMGS.length;
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % n), 4000);
    return () => clearInterval(t);
  }, [n]);
  return (
    <div id="carouselExampleIndicators" className="carousel slide">
      <div className="carousel-inner">
        {CAROUSEL_IMGS.map((src, i) => (
          <div className={`carousel-item${i === idx ? ' active' : ''}`} key={i}>
            <img
              src={src}
              className="d-block w-100"
              alt={`Promotion ${i + 1}`}
              onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }}
            />
          </div>
        ))}
      </div>
      <button type="button" className="carousel-control-prev" onClick={() => setIdx((i) => (i - 1 + n) % n)}>
        <span className="carousel-control-prev-icon" aria-hidden="true" />
        <span className="visually-hidden">Previous</span>
      </button>
      <button type="button" className="carousel-control-next" onClick={() => setIdx((i) => (i + 1) % n)}>
        <span className="carousel-control-next-icon" aria-hidden="true" />
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
}

/* 3-level nested menu: Sport (nav-link) → League (nav-content) → Matches (nav-second-level).
   Each level is a real Bootstrap `.collapse` toggled by React state via the `show` class;
   the `.reddy-home .collapse{visibility:visible}` immunization keeps Tailwind's
   `.collapse{visibility:collapse}` utility from hiding the opened lists. */
export default function Sidebar({ onCloseDrawer }) {
  /* The mobile drawer slide-in is handled purely by CSS: `.toggle-sidebar .sidebar`
     (bundle + the `#sidebar` supplement override) sets left:0 / width:55%. The
     backdrop + scroll-lock are CSS too. No inline positioning needed. */
  const navigate = useNavigate();
  const [openSport, setOpenSport] = useState({});
  const [openLeague, setOpenLeague] = useState({});
  const toggleSport = (id) => setOpenSport((s) => ({ ...s, [id]: !s[id] }));
  const toggleLeague = (key) => setOpenLeague((s) => ({ ...s, [key]: !s[key] }));
  const stop = (e) => e.preventDefault();
  const openMatch = (e, name) => { e.preventDefault(); navigate(`/match/${slugify(name)}`); };

  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        <img className="mobile-logo" src={MOBILE_LOGO} alt="Reddy Anna Book"
             onError={(e) => { e.currentTarget.style.display = 'none'; }} />
        {/* in-drawer close button (shown only when the drawer is open, via @media) */}
        <i className="bi bi-list-nested toggle-sidebar-btn" role="button" aria-label="Close menu" onClick={onCloseDrawer} />

        {SIDEBAR_ITEMS.map((sp) => {
          const leagues = SIDEBAR_TREE[sp.label] || [];
          const hasKids = leagues.length > 0;
          const sOpen = !!openSport[sp.id];
          return (
            <li className="nav-item" key={sp.id}>
              <a
                className="nav-link"
                href={sp.href}
                aria-expanded={hasKids ? sOpen : undefined}
                onClick={(e) => {
                  e.preventDefault();
                  if (hasKids) toggleSport(sp.id);
                  else if (sp.href && sp.href !== '#') navigate(sp.href);
                }}
              >
                <IconImg src={sp.icon} />
                <span>{sp.label}</span>
                <i className="bi bi-caret-down ms-auto" />
              </a>

              <ul className={`nav-content collapse${sOpen ? ' show' : ''}`}>
                {leagues.map((lg, li) => {
                  const key = `${sp.id}-${li}`;
                  const lOpen = !!openLeague[key];
                  return (
                    <li key={key}>
                      <a href="#!" aria-expanded={lOpen}
                         onClick={(e) => { e.preventDefault(); toggleLeague(key); }}>
                        <span>{lg.league}</span>
                        <i className="bi bi-caret-down ms-auto" />
                      </a>
                      <div className={`collapse${lOpen ? ' show' : ''}`}>
                        <ul className="nav-second-level">
                          {lg.matches.map((mt, mi) => (
                            <li key={mi}>
                              <a href="#!" className="final-link" onClick={(e) => openMatch(e, mt)}>
                                <span>{mt}</span>
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}
      </ul>

      <SidebarCarousel />
    </aside>
  );
}
